import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

const LANGUAGE_KEY = 'lang';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private defaultLang: 'ar' | 'en' = 'ar';
  private isBrowser: boolean;
  private languageSubject: BehaviorSubject<'ar' | 'en'>;

  public language$;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);

    const initialLang = this.getStoredLanguage();
    this.languageSubject = new BehaviorSubject<'ar' | 'en'>(initialLang);
    this.language$ = this.languageSubject.asObservable();
  }

  setLanguage(lang: 'ar' | 'en'): void {
    this.languageSubject.next(lang);
    if (this.isBrowser) {
      localStorage.setItem(LANGUAGE_KEY, lang);
      
    }
  }

  getLanguage(): 'ar' | 'en' {
    return this.languageSubject.value;
  }

  private getStoredLanguage(): 'ar' | 'en' {
    if (!this.isBrowser) return this.defaultLang;
    const lang = localStorage.getItem(LANGUAGE_KEY);
    return (lang === 'en' || lang === 'ar') ? lang : this.defaultLang;
  }

  applyLanguageSettings(lang: 'ar' | 'en'): void {
    const html = this.document.documentElement;
    html.lang = lang === 'ar' ? 'ar-SA' : 'en-US';
    html.dir = lang === 'ar' ? 'rtl' : 'ltr';

    const body = this.document.body;
    body.classList.toggle('rtl', lang === 'ar');
    body.classList.toggle('ltr', lang === 'en');
  }
}
